import { render, staticRenderFns } from "./NewLoanComplete.vue?vue&type=template&id=b0ccfef4"
import script from "./NewLoanComplete.vue?vue&type=script&lang=js"
export * from "./NewLoanComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports